import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X, LayoutDashboard } from "lucide-react";
import Logo from "./Logo";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

const NAV = [
  { label: "About", to: "/about" },
  { label: "Experiences", to: "/experiences" },
  { label: "Memberships & Pricing", to: "/memberships" },
  { label: "Step Up Booking", to: "/step-up-booking" },
  { label: "Media & Merchandise", to: "/media-merchandise" },
  { label: "Contact", to: "/contact" },
];

export default function PublicNav() {
  const [open, setOpen] = useState(false);
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-6 xl:flex">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
              className={`font-display text-sm font-semibold transition-colors hover:text-brandblue ${pathname === n.to ? "text-brandblue" : "text-navy"}`}
            >
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="hidden items-center gap-3 xl:flex">
          {user ? (
            <Button variant="ghost" data-testid="nav-dashboard-btn" className="font-display font-semibold text-navy"
              onClick={() => navigate(isAdmin ? "/admin" : "/dashboard")}>
              <LayoutDashboard className="mr-2 h-4 w-4" />Dashboard
            </Button>
          ) : (
            <Link to="/login" data-testid="nav-login-btn" className="font-display text-sm font-semibold text-navy hover:text-brandblue">Parent Login</Link>
          )}
          <Button data-testid="nav-explore-btn" className="bg-brandblue font-display font-semibold hover:bg-blue-700" onClick={() => navigate("/experiences")}>
            Explore Experiences
          </Button>
        </div>
        <button className="xl:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X className="h-6 w-6 text-navy" /> : <Menu className="h-6 w-6 text-navy" />}
        </button>
      </div>
      {open && (
        <div className="border-t border-slate-200 bg-white px-5 py-4 xl:hidden">
          <div className="flex flex-col gap-3">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="font-display font-semibold text-navy">{n.label}</Link>
            ))}
            <div className="mt-2 flex flex-col gap-2 border-t border-slate-100 pt-3">
              {user ? (
                <Button className="bg-brandblue font-display" onClick={() => { setOpen(false); navigate(isAdmin ? "/admin" : "/dashboard"); }}>Dashboard</Button>
              ) : (
                <>
                  <Button variant="outline" className="font-display" onClick={() => { setOpen(false); navigate("/login"); }}>Parent Login</Button>
                  <Button className="bg-brandblue font-display" onClick={() => { setOpen(false); navigate("/experiences"); }}>Explore Experiences</Button>
                  <Button variant="ghost" className="font-display text-navy" onClick={() => { setOpen(false); navigate("/step-up-booking"); }}>How to Book with Step Up</Button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
